import "components/shared/header/PageHeaderRight.scss";

import React, { HTMLAttributes } from "react";

import classNames from "classnames";

type PageHeaderRightProps = HTMLAttributes<HTMLDivElement>;

const PageHeaderRight = ({ children, className, ...divProps }: PageHeaderRightProps): JSX.Element => {
  return (
    <div className={classNames("csa-page-header-right p-1 pe-lg-0", className)} {...divProps}>
      {children}
    </div>
  );
};

export default PageHeaderRight;
